import { useTabState } from 'reakit/Tab';
import Image from 'next/image';
import cc from 'classnames';

import styles from '@/styles/pages/home.module.css';
import HomeSectionHero from './HomeSectionHero';
import Tab from './Tab';
import TabList from './TabList';
import TabPanel from './TabPanel';

export default function CreatorsTab() {
  const tabCreators = useTabState({ selectedId: `content-ui` });

  return (
    <>
      <div
        className={cc(
          styles.gridCreators,
          styles.gridTabs,
          `my-8 pt-1 md:mt-0 md:pt-0 lg:mb-12`,
        )}
      >
        <TabList
          tab={tabCreators}
          aria-label="GraphCMS for content creators"
          withBottomBorder
          className="h-full items-center justify-center text-light-haiti"
        >
          <Tab tab={tabCreators} id="content-ui" activeColor="text-rose">
            Content UI
          </Tab>
          <Tab
            tab={tabCreators}
            id="localization"
            className="mx-8"
            activeColor="text-rose"
          >
            Localization
          </Tab>
          <Tab tab={tabCreators} id="ui-extensions" activeColor="text-rose">
            UI Extensions
          </Tab>
        </TabList>
      </div>

      <div>
        <TabPanel
          tab={tabCreators}
          id="content-ui"
          className={cc(
            styles.gridCreators,
            `focus:outline-none lg:min-h-[548px]`,
          )}
        >
          <Image
            src="/images/home/content-ui.svg"
            alt="GraphCMS Content UI with asset picker, rich text, and string fields"
            width={802}
            height={616}
          />

          <div>
            <HomeSectionHero
              badge="Graphcms For Content Creators"
              title="Finally A CMS That Works With You"
              description="Deliver perfect customer experiences every time. With a fast, lightweight, and intuitive content management studio at your fingertips, GraphCMS let’s you deliver your most ambitious ideas the way you envision them."
              colors={{ badge: `text-rose` }}
              cta={{
                href: `/for-content-creators`,
                label: `Explore GraphCMS for Content Creators`,
              }}
            />
          </div>
        </TabPanel>
        <TabPanel
          tab={tabCreators}
          id="localization"
          className={cc(
            styles.gridCreators,
            `focus:outline-none lg:min-h-[548px]`,
          )}
        >
          <Image
            src="/images/home/localization.svg"
            alt="Example of localized field for four languages, English, German, French (France), and French (Canada)"
            width={716}
            height={525}
          />

          <div>
            <HomeSectionHero
              badge="Graphcms For Content Creators"
              title="Make Your Customers Feel At Home"
              description="GraphCMS provides localization out of the box. Granular field-based localizations, fallbacks, locale-based publishing, and granular locale based permissions, create content for the world on your terms."
              colors={{ badge: `text-rose` }}
              cta={{
                href: `/for-content-creators`,
                label: `Explore GraphCMS for Content Creators`,
              }}
            />
          </div>
        </TabPanel>
        <TabPanel
          tab={tabCreators}
          id="ui-extensions"
          className={cc(
            styles.gridCreators,
            `focus:outline-none lg:min-h-[548px]`,
          )}
        >
          <Image
            src="/images/home/ui-extensions.svg"
            alt="GraphCMS management UI with three fields: product name, reference, and promotion"
            width={741}
            height={492}
          />

          <div>
            <HomeSectionHero
              badge="Graphcms For Content Creators"
              title="Extensibility To Make It Yours"
              description="Combining UI Extensions with Content Based Permissions lets you extend the basic functionality of the GraphCMS web app. Build on our UI to bring in your favorite integrations, or personalize the interface to suit your preferences."
              colors={{ badge: `text-rose` }}
              cta={{
                href: `/for-content-creators`,
                label: `Explore GraphCMS for Content Creators`,
              }}
            />
          </div>
        </TabPanel>
      </div>
    </>
  );
}
